export const DEFAULT_CANVAS_TITLE = "Untitled";
export const DEFAULT_PAGE_TITLE = DEFAULT_CANVAS_TITLE;
export const CANVAS_NAME = { SINGULAR: "document", PLURAL: "documents" };
export const PAGE_NAME = { SINGULAR: "page", PLURAL: "pages" };
export const HOMEPAGE_ROUTE = "/d";
export const DOWNLOADS_PAGE = "https://www.moment.dev/download";

export const LOCAL_WORKSPACE_NAME = "local";
